<template>
  <div :class="$style.footer">
    <div v-if="orders.length" :class="$style.cards">
      <DoneOrderCard v-for="order in orders" :key="order.id" :order="order" />
    </div>
    <div :class="$style.info">
      <div>© {{ year }} Все права защищены</div>
      <div>Шиномонтажный калькулятор</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DoneOrderCard from "./DoneOrderCard.vue";

export default {
  name: "Footer",
  components: {
    DoneOrderCard,
  },

  computed: {
    year() {
      return new Date().getFullYear();
    },
    ...mapGetters("orders", ["doneOrders"]),
    orders() {
      return this.doneOrders.flatMap((item) => item.orders || []);
    },
  },
};
</script>

<style lang="scss" module>
.footer {
  background-color: $bg-primary;
  padding: 1rem 1rem 1rem;
  border-top: 1px solid $t-primary;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
  .cards {
    display: flex;
    flex-wrap: nowrap;
    gap: 1rem;
    min-width: 0;
    overflow: hidden;

    > * {
      flex-shrink: 0;
      width: 30rem;
    }
  }
  .info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    font-size: 1rem;
    line-height: 1;
    font-weight: 600;
  }
}
</style>
